const roles = {
  name: "Name",
  description: "Role Description",
}

export default roles